<template>
    <MonitorLayoutTemplate
        table_title="蘇花路廊監控總覽"
        :show_search_text="false"
    >

        <template #data_table>
            <LandslideSWCB
                :key="default_value_radar_monitor"
                :default_value="default_value_radar_monitor"
            />
            <br>
            <LandslideTRA
                :key="default_value_landslide"
                :default_value="default_value_landslide"
            />
        </template> 
    </MonitorLayoutTemplate>
</template>

<script>
import MonitorLayoutTemplate from '@/components/monitor/_tool/layout_template.vue'
import LandslideSWCB from '@/components/monitor/swcb/landslide.vue'
import LandslideTRA from '@/components/monitor/tra/landslide.vue'

export default {
    name: 'SuhuaMonitor',

    components: {
        MonitorLayoutTemplate,
        LandslideSWCB,
        LandslideTRA,
    },

    data() {
        return {
            default_value_landslide: 297,
            default_value_radar_monitor: 329,
        }
    },

    computed: {},

    methods: {},
}
</script>

<style lang="scss" scoped>
</style>
